module.exports = __webpack_public_path__ + "img/hf-symbol.508d21b9.png";